interface Props {
  title: string;
  description?: React.ReactNode;
  actions?: React.ReactNode;
}

export function Topbar({ title, description, actions }: Props): JSX.Element {
  return (
    <div className="border-b border-mb-border bg-mb-surface-elev px-6 py-4 flex items-center justify-between gap-4">
      <div>
        <h1 className="font-display text-xl font-semibold text-mb-text">{title}</h1>
        {description ? (
          <div className="text-sm text-mb-text-muted mt-0.5">{description}</div>
        ) : null}
      </div>
      {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
    </div>
  );
}
